module.exports = __webpack_public_path__ + "static/media/invite-referral.b1be002d.png";